// @ts-nocheck
import { afterInteraction } from '../common/afterInteraction';

export default defineNuxtPlugin(() => {
  const app = useNuxtApp();
  (function (w: any, t: any) {
    w.TiktokAnalyticsObject = t;
    const ttq = (w[t] = w[t] || []);
    ttq.methods = [
      'page', 'track', 'identify', 'instances', 'debug',
      'on', 'off', 'once', 'ready', 'alias', 'group',
      'enableCookie', 'disableCookie',
    ];
    ttq.setAndDefer = function (t: any, e: any) {
      t[e] = function (...args: any[]) {
        t.push([e, ...args]);
      };
    };
    for (let i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(ttq, ttq.methods[i]);
    }
    ttq.instance = function (t: any) {
      const e = ttq._i[t] || [];
      for (let i = 0; i < ttq.methods.length; i++) {
        ttq.setAndDefer(e, ttq.methods[i]);
      }
      return e;
    };
    ttq.load = function (e: string, n: any) {
      const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ttq._i = ttq._i || {};
      ttq._i[e] = [];
      ttq._i[e]._u = i;
      ttq._t = ttq._t || {};
      ttq._t[e] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[e] = n || {};
      afterInteraction().then(() => {
        const o = document.createElement('script');
        o.type = 'text/javascript';
        o.async = true;
        o.src = `${i}?sdkid=${e}&lib=${t}`;
        document.head.appendChild(o);
      });
    };

    ttq.load('CNNEL4BC77UDOE8IQJ0G');
    ttq.page();
  })(window, 'ttq');

  const track = (eventName: string, eventData?: Record<string, any>): void => {
    if (import.meta.client && window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track(eventName, eventData || {});
    } else {
      app.$logger.note({
        category: 'tiktokPixel',
        message: 'ttq.track is not initialized',
        level: 'warning',
      });
    }
  };

  const identify = ({ email }: { email?: string }): void => {
    if (import.meta.client && window.ttq && typeof window.ttq.identify === 'function') {
      window.ttq.identify({ email });
    } else {
      app.$logger.note({
        category: 'tiktokPixel',
        message: 'ttq.identify is not initialized',
        level: 'warning',
      });
    }
  };

  return {
    provide: {
      ttTrack: track,
      ttIdentify: identify,
    },
  };
});
